import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Paper, Image, Text, Loader, MultiSelect } from '@mantine/core'
import { getAllProductsList } from '../../../services/products'
import { updateSourcingRequest } from '../../../services/sourcing-request'
import { notificationSuccess, notificationError } from '../../ui/Notifications'
import { useDebouncedCallback } from '@mantine/hooks'

const FormSubmitRecommendation = ({ dataSourcingRequest, onCloseModal, reloadList }) => {
  const [loadingForm, setLoadingForm] = useState(false)
  const [searchProduct, setSearchProduct] = useState('')
  const [loadingProduct, setLoadingProduct] = useState(false)
  const [productCount, setProductCount] = useState(0)
  const [storeSelectedProduct, setStoreSelectedProduct] = useState([])
  const [selectedProduct, setSelectedProduct] = useState([])
  const [productList, setProductList] = useState([])

  const submitProductRecommendation = async () => {
    setLoadingForm(true)
    const payload = {
      request_number: dataSourcingRequest.request_number,
      title: dataSourcingRequest.title,
      brand: dataSourcingRequest.brand,
      quantity: dataSourcingRequest.quantity,
      quantity_unit: dataSourcingRequest.quantity_unit,
      currency: dataSourcingRequest.currency,
      price: dataSourcingRequest.price,
      user_id: dataSourcingRequest.user_id,
      agent_id: dataSourcingRequest.agent_id,
      description: dataSourcingRequest.description,
      products: selectedProduct
    }
    try {
      const response = await updateSourcingRequest(dataSourcingRequest.id, payload)
      if (response.success) {
        onCloseModal()
        reloadList()
        notificationSuccess('Update Sourcing Request Successfully', 'You have been updated data sourcing request')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      const captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your form'
      notificationError('Update Sourcing Request Error', captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleGetListProduct = useDebouncedCallback(async () => {
    setLoadingProduct(true)
    const parameter = {
      'filter[title][like]': searchProduct,
      'page[num]': 1,
      'page[limit]': 10,
    }
    try {
      const response = await getAllProductsList(parameter)
      const responseProduct = response.data
      let dataProduct = []
      const remapDataProduct = responseProduct.map((val) => {
        return {
          label: val.attributes.title,
          value: `${val.attributes.id}`,
          image: val.attributes.image
        }
      })
      
      if (storeSelectedProduct.length > 0) {
        const joinData = remapDataProduct.concat(storeSelectedProduct)
        const findDuplicate = joinData.reduce((result, item) => {
          const removed = result.filter((val) => val.value !== item.value)
          return [...removed, item]
        }, [])
        dataProduct = findDuplicate
      } else {
        dataProduct = remapDataProduct
      }
      setProductList(dataProduct)
      setProductCount(remapDataProduct.length)
    } catch (error) {
      console.log(error)
    } finally {
      if (productList) {
        setLoadingProduct(false)
      }
    }
  }, 500)

  useEffect(() => {
    if (dataSourcingRequest !== null) {
      handleSetForm(dataSourcingRequest)
    }
  }, [dataSourcingRequest])

  useEffect(() => {
    handleGetListProduct()
    // eslint-disable-next-line
  }, [searchProduct])

  const handleSetForm = (val) => {
    if (val.products.length > 0) {
      const dataProduct = val.products
      const remapDataProduct = dataProduct.map((val) => {
        return {
          label: val.title,
          value: `${val.id}`,
          image: val.image
        }
      })
      setStoreSelectedProduct(remapDataProduct)
      const mappingIdProduct = remapDataProduct.map((val) => {
        return `${val.value}`
      })
      setSelectedProduct(mappingIdProduct)
    }
  }

  const renderProductOption = ({ option }) => {
    return (
      <Group justify='space-between' align='center' gap="xs">
        <Flex gap='sm' align='center'>
          <Paper shadow="sm" w={52} withBorder radius='md'>
            <Image w={50} h={50} radius='md' src={option.image} />
          </Paper>
          <Box>
            <Text fz={12} fw='600' lineClamp={2}>{option.label}</Text>
          </Box>
        </Flex>
      </Group>
    )
  }

  const loadingDataProduct = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }

  const handleSelect = (valueProduct) => {
    const filteredProduct = productList.find((val) => {
      return val.value === `${valueProduct}`
    })
    setStoreSelectedProduct(oldVal => [...oldVal, filteredProduct])
    setSelectedProduct(oldVal => [...oldVal, filteredProduct.value])
  }

  const handleUnselectProduct = (valueProduct) => {
    const unselectProduct = storeSelectedProduct.filter((val) => {
      return val.value !== `${valueProduct}`
    })
    setStoreSelectedProduct(unselectProduct)
    const mappingIdProduct = unselectProduct.map((val) => {
      return `${val.value}`
    })
    setSelectedProduct(mappingIdProduct)
  }

  return (
    <Box>
      <Box mb='md'>
        <MultiSelect
          name='products'
          label='Select the Product you want to recommend'
          value={selectedProduct}
          data={productList}
          defaultValue={selectedProduct}
          onOptionSubmit={(val) => handleSelect(val)}
          onRemove={(val) => handleUnselectProduct(val)}
          size='xs'
          searchable
          searchValue={searchProduct}
          onSearchChange={setSearchProduct}
          renderOption={renderProductOption}
          nothingFoundMessage={!loadingProduct ? productCount > 0 ? '' : 'No Product Found' : loadingDataProduct()}
          hidePickedOptions
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitProductRecommendation()} disabled={selectedProduct.length === 0}>Submit</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormSubmitRecommendation